module.exports = __webpack_public_path__ + "static/media/DHL.b442a0c5.png";